import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { CheckIcon, CloseIcon, CheckNormalIcon, BackIcon } from "../assets/Icons";

const CloneModal = ({ show, onClose, cloneVersion }) => {
  const handleCancelModal = () => {
    onClose(true);
  };
  const handleYesClick = async (e) => {
    await cloneVersion(e, true);
  };
  //   const addMore = () => {
  //     setAccessList((prev) => !prev);
  //   };

  return (
    <Modal show={show} onHide={onClose} centered backdrop="static" className="sim-body-modal">
      <Modal.Body className="sim-body-modal">
        <div className="clonemadal">
          <h4>Make a clone</h4>
          <p>Do you really want to clone this Workflow?</p>
          <div className="modal-footer justify-content-center p-0 pb-0">
            <div className="modal-footer-btns gap-2">
              <button onClick={onClose} className="cancel">
                Cancel
              </button>
              <button className="save" onClick={handleYesClick}>
                Yes
              </button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CloneModal;
